import config from '../lib/config';
import { WILDCARD_ORG_ID } from '../lib/api/API';
import { childrenPageViews } from '../views/pages';
import BluLicense from '../lib/license';

const getUserOrgRoles = ({ user, orgId}) => {
  const userOrgRoles = user && user.orgRoles ? user.orgRoles
    .filter(role => role.orgId === orgId)
    .map(role => role.roleName) : [];
  return userOrgRoles;
};

export const checkRoleNav = (route, user, orgId, settings) => {
  const userOrgRoles = getUserOrgRoles({ user, orgId });
  const superUser = user && (user.superadmin === true || user.superadmin === 'true');
  const mode = orgId === WILDCARD_ORG_ID ? 'admin': 'normal';
  const pageConfig = childrenPageViews.find(pc => pc.route === route)

  // get org data to check 'market' value
  let orgsToSearch = settings.userOrgs.length ? settings.userOrgs : settings.currentUserOrgs
  let currentOrgData = orgsToSearch.find(({ id }) => id === orgId) || null

  if(!pageConfig){
    return false
  }

  // Check if current mode (admin/normal) matches what the menu item allows.
  // (Default is 'normal' if menu item doesn't specify modes.)
  if (!(pageConfig.modes || ['normal']).includes(mode)) {
    return false;
  }

  // Check that a valid license has been built
  if(!BluLicense.isSet()){
    return false
  }

  // Check the route against the license
  if(!BluLicense.isAllowedPage(pageConfig.route)){
    return false
  }

  if (pageConfig.featureFlag){
    if (!superUser && pageConfig.featureFlag && (!user.config || !user.config[pageConfig.featureFlag])){
      return false
    }
  }
   
  // This logic is specifically targeting the BILLING page
  if(pageConfig.stripeCustomersOnly && currentOrgData){
    if (!currentOrgData.stripeCustomerId && !currentOrgData.config?.stripe_customer_id) // TODO: I'm not sure that stripeCustomerId is ever present but leaving it to be safe
      return false
  }

  if(pageConfig.markets && currentOrgData){
    if(!pageConfig.markets.find(marketValue => marketValue === currentOrgData.market))
      return false
  }

  if (superUser || pageConfig.roles === undefined) {
    return true;
  }

  if(pageConfig.roles.includes('*')){
    return true
  }

  if (pageConfig.roles.some(role => userOrgRoles.includes(role))) {
    return true;
  }


  if (userOrgRoles.includes('administrator') && pageConfig.labs
    && localStorage.getItem('labsEnabled')) {
    return true;
  }

  return false;
}

/*
"Extracted" from SidebarView.
Takes `menuItem` as argument.
Returns `true` if `menuItem` has any child items in `config`
for the logged-in user; returns `false` otherwise.
*/
const getCleanChildren = ({
  menuItem,
  user,
  orgId,
  settings
}) => {
  const children = menuItem.children || [];
  return children.filter((c) => {
    return checkRoleNav(`${menuItem.type}/${c.type}`, user, orgId, settings)
  });
};

export const getMenu = (orgId, settings) => {
  const menu = (config.menuItems || [])
    .map(menuItem => {
      return {
        ...menuItem,
        children: getCleanChildren({
          menuItem,
          user: settings.user,
          orgId,
          settings
        })
      };
    })
    .filter(menuItem => menuItem.children.length > 0)
  return menu
}

export const isSecondLevelSelected = (childMenuItem, activeRoute) => {
    // in some cases, we have routes that align with 
    // views that act like children but should not be
    // shown in the side menu as children with their
    // own menu item. simply add the route in `children`
    // inside config.json - see `results` under `reporting`
    // for an example
     
    return (
        activeRoute.toLowerCase() === childMenuItem.type
        || (childMenuItem.children && childMenuItem.children.find(child => activeRoute.toLowerCase() === child))
    )
}
